import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { compose } from 'recompose';
import { observer } from 'mobx-react';
import { IconButton } from '@mui/material';

import { InfoTag } from '../../../../../../../components/Tags/styles';
import AttachmentSlider from '../../../../../../components/AttachmentSlider';
import useComponentMounted from '../../../../../../../hooks/useComponentMounted';
import Announcement, { ALL_CLIENTS_TAG } from '../../../../../../Model/Announcement';
import ConfirmDialog from '../../../../../../components/ConfirmDialog';
import useToast from '../../../../../../hooks/useToast';
import AnnouncementModal from '../../../AnnouncementModal';

import {
  Card,
  Message,
  TagContainer,
  BottomRow,
  DateText,
  LikesContainer,
  HeartIcon,
  TrashIcon,
  EditIcon,
} from './styles';
import texts from './texts.json';

const AnnouncementItem = ({ announcement }) => {
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [isAnnouncementModalOpen, setIsAnnouncementModalOpen] = useState(false);

  const { showToast } = useToast();
  const isComponentMountedRef = useComponentMounted();

  const {
    message,
    tagName,
    tagId,
    createdAt,
    likes,
    attachments,
  } = announcement;

  const removeAnnouncement = useCallback(async () => {
    await announcement.remove();
    showToast(texts.success);
    if (isComponentMountedRef.current) {
      setIsConfirmDialogOpen(false);
    }
  }, [announcement, showToast, isComponentMountedRef]);

  return (
    <>
      <Card>
        <DateText>
          {moment(createdAt.toDate()).fromNow()}
        </DateText>
        <Message>{message}</Message>
        {tagId !== ALL_CLIENTS_TAG.id && (
          <TagContainer>
            <InfoTag>{tagName}</InfoTag>
          </TagContainer>
        )}
        {attachments.length > 0 && <AttachmentSlider attachments={attachments} />}
        <BottomRow>
          <LikesContainer>
            <HeartIcon />
            {likes}
          </LikesContainer>
          <div>
            <IconButton onClick={() => setIsAnnouncementModalOpen(true)}>
              <EditIcon />
            </IconButton>
            <IconButton onClick={() => setIsConfirmDialogOpen(true)}>
              <TrashIcon />
            </IconButton>
          </div>
        </BottomRow>
      </Card>
      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onCancel={() => setIsConfirmDialogOpen(false)}
        onConfirm={removeAnnouncement}
        dialogTexts={{
          title: texts.removeAnnouncement,
          content: texts.removeAnnouncementMessage,
        }}
      />
      {isAnnouncementModalOpen && (
        <AnnouncementModal
          isOpen={isAnnouncementModalOpen}
          onDidDismiss={() => setIsAnnouncementModalOpen(false)}
          announcement={announcement}
        />
      )}
    </>
  );
};

AnnouncementItem.propTypes = {
  announcement: PropTypes.instanceOf(Announcement).isRequired,
};

export default compose(
  observer,
)(AnnouncementItem);
